import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { connectionPropertiesMenuItem } from '../menu-item/connection-properties-menu-item';
import { deleteObstructionMenuItem } from '../menu-item/delete-obstruction-menu-item';
import { obstructionPropertiesMenuItem } from '../menu-item/obstruction-properties-menu-item';

export const obstructionMenuList: Array<ContextMenuList> = [
	{ type: ContextMenuListItemType.Divider },
	deleteObstructionMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	connectionPropertiesMenuItem(),
	obstructionPropertiesMenuItem()
];
